import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const NewTab = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6H14V2H6C3.79086 2 2 3.79086 2 6V26C2 28.2091 3.79086 30 6 30H26C28.2091 30 30 28.2091 30 26V18H26V26H6L6 6ZM26 2H18V6H23.1716L14.5858 14.5858C13.8047 15.3669 13.8047 16.6332 14.5858 17.4142C15.3668 18.1953 16.6332 18.1953 17.4142 17.4142L26 8.82846V14H30V6V2H26Z"
        fill={color}
      />
    </svg>
  );
};

export default NewTab;
